import type { InjectionKey } from 'vue';
import { inject, provide } from 'vue';

const formRowKey: InjectionKey<boolean> = Symbol('sphFormRow');

/**
 * Marks the direct fields of a row, which line their rows up with their neighbours'. A field
 * provides `false` again, so a row nested inside its control does not reach past it.
 */
export function provideFormRow(inRow: boolean): void {
    provide(formRowKey, inRow);
}

export function injectFormRow(): boolean {
    return inject(formRowKey, false);
}

const reserveDescriptionKey: InjectionKey<boolean> = Symbol('sphFieldsetReserveDescription');

/**
 * Set by `SphColumns`: a fieldset in a column keeps a line free for the description it does not
 * have, so the fields of neighbouring columns start level. A fieldset provides `false` again, so
 * only the columns themselves reserve it, not the fieldsets nested in them.
 */
export function provideReserveDescription(reserve: boolean): void {
    provide(reserveDescriptionKey, reserve);
}

export function injectReserveDescription(): boolean {
    return inject(reserveDescriptionKey, false);
}

export type FormFieldErrors = Array<string | null | undefined> | string | null | undefined;

export function normalizeErrors(errors: FormFieldErrors): string[] {
    const list = Array.isArray(errors) ? errors : [errors];

    return [...new Set(list.filter((error): error is string => !!error))];
}
